import { createContext } from 'react';
export interface IPageBuilderContext {
  loadFn?: () => Promise<any>;
}
export const PageBuilderContext = createContext<IPageBuilderContext>({});

export default PageBuilderContext;
